module.exports = __webpack_public_path__ + "img/213.problem_bed_smell.8e4c1264.svg";